var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-modal',{attrs:{"visible":_vm.visible,"width":1000,"title":"编辑记录","footer":null},on:{"cancel":function($event){return _vm.$emit('cancel')}}},[_c('a-table',{attrs:{"loading":_vm.loading,"columns":_vm.columns,"data-source":_vm.list,"pagination":_vm.pagination,"bordered":"","row-key":"id","size":"small"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }